import React from 'react';
import classnames from 'classnames';

import Image from 'components/Image';
import { ITooltipData } from 'components/ModalTooltip/types';

interface Props {
  children: React.ReactNode,
  defaultCursor: boolean,
  id: number,
  image: string,
  isBlocked: boolean,
  isLoading: boolean,
  isUsable: boolean,
  name: string,
  onClick: Function,
  tooltipData: ITooltipData,
}

export default function InventoryItemComponent(props: Props) {
  const {
    children,
    defaultCursor,
    id,
    image,
    isBlocked,
    isLoading,
    isUsable,
    name,
    onClick,
    tooltipData,
  } = props;
  return (
    <li
      className={classnames(
        'item',
        isBlocked && 'items--blocked',
      )}
    >
      <div
        className={classnames(
          'icon icon--inventory icon--emphasize',
          isUsable && 'icon--usable',
          isLoading && 'icon--is-loading',
        )}
        data-quality-id={id}
      >
        <Image
          icon={image}
          alt={name}
          type="small-icon"
          tooltipData={tooltipData}
          onClick={onClick}
          defaultCursor={defaultCursor}
        />
        {children}
      </div>
    </li>
  );
}